import firebase from "firebase/app";
import { tOrder, tOrderStatus, validate } from "tmt_api/src/types/types.validator";

export type tQueryOrdersParams = {
  id?: string;
  brandId?: string;
  retailerId?: string;
  repId?: string;
  term?: string;
  status?: tOrderStatus | tOrderStatus[];
  promotionCode?: string;
};

export const documentOrder = (id: string): firebase.firestore.DocumentReference<tOrder> =>
  firebase
    .firestore()
    .collection("orders")
    .doc(id)
    .withConverter<tOrder>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tOrder")(snapshot.data()),
    });

export const queryOrder = (params?: tQueryOrdersParams): firebase.firestore.Query<tOrder> => {
  let collectionRef: firebase.firestore.Query = firebase
    .firestore()
    .collection("orders")
    .orderBy("dateCreated", "desc");

  if (params?.id) collectionRef = collectionRef.where("orderId", "==", params.id);
  if (params?.brandId) collectionRef = collectionRef.where("connection.brand.id", "==", params.brandId);
  if (params?.retailerId) collectionRef = collectionRef.where("connection.boutique.id", "==", params.retailerId);
  if (params?.repId) collectionRef = collectionRef.where("cart.rep.id", "==", params.repId);
  if (params?.term)
    collectionRef = collectionRef.where("searchableValues", "array-contains", params.term.toLowerCase());
  if (params?.status)
    collectionRef = collectionRef.where("orderStatus", Array.isArray(params?.status) ? "in" : "==", params.status);
  if (params?.promotionCode) collectionRef = collectionRef.where("cart.discountCode", "==", params.promotionCode);

  return collectionRef.withConverter<tOrder>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tOrder")(snapshot.data()),
  });
};

export const queryPaginated = async (
  params?: tQueryOrdersParams & { limit?: number; prev?: string; next?: string },
): Promise<firebase.firestore.Query<tOrder>> => {
  let collectionRef = queryOrder(params);

  if (params?.prev) {
    const orderFirstDocument = await documentOrder(params.prev).get();
    collectionRef = collectionRef.endBefore(orderFirstDocument);
  }

  if (params?.next) {
    const orderLastDocument = await documentOrder(params.next).get();
    collectionRef = collectionRef.startAfter(orderLastDocument);
  }

  if (params?.limit) {
    collectionRef = params.prev ? collectionRef.limitToLast(params.limit) : collectionRef.limit(params.limit);
  }

  return collectionRef;
};
